import { useState } from "react";
import { BsFillSendFill } from "react-icons/bs";
import { useSelector } from "react-redux";

const MessageInput = ({ isLiveChat, handleSendMessage, inputRef }) => {
  const { data: userData } = useSelector((state) => state.user);
  const [voiceText, setVoiceText] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage(voiceText, removeInput);
      setVoiceText("");
    }
  };

  const handleInputChange = (event) => {
    setVoiceText(event.target.value);
  };

  const removeInput = () => {
    setVoiceText("");
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
      console.log("Input cleared");
    } else {
      console.warn("inputRef is not defined or does not have a current value");
    }
  };

  return (
    <div
      className="w-[80%] h-[55px] px-2 rounded-[14px] mx-auto bg-[#cecdcd63] 
                 flex gap-2 shadow-[0px_10px_50px_rgba(0,0,0,0.1)] 
                 items-center overflow-hidden"
    >
      <input
        onKeyDown={handleKeyDown}
        className="flex-1 h-full bg-transparent border-none outline-none 
                   text-gray-500 text-[12px] placeholder:text-[#aeaeae] 
                   placeholder:text-[12px] placeholder:font-light 
                   placeholder:tracking-[0.9px]"
        type="text"
        placeholder={`${
          !isLiveChat
            ? "Ask anything to debAI chatbot..."
            : "Say something in live chat..."
        }`}
        onChange={handleInputChange}
        value={voiceText}
        ref={inputRef}
      />

      <div
        className="h-[80%] w-[50px] grid place-items-center text-white 
                   bg-[#686de0] rounded-lg transition-all 
                   duration-300 ease-in-out cursor-pointer hover:bg-[#1a21c9]"
        onClick={() => handleSendMessage(voiceText, removeInput)}
      >
        <BsFillSendFill className="text-[1.52rem] " />
      </div>
    </div>
  );
};

export default MessageInput;
